module.exports = __webpack_public_path__ + "img/melissa-dashboard1.508e112b.png";